import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PageDocsFilterContent from './PageDocsFilterContent';

function PageDocsFilter(props) {
    const { layout } = props;

    return (
        <React.Fragment>
            <PageDocsFilterContent layout={layout} />
        </React.Fragment>
    );
}

PageDocsFilter.propTypes = {
    layout: PropTypes.oneOf(['classic', 'full']),
};

PageDocsFilter.defaultProps = {
    layout: 'classic',
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(PageDocsFilter);
